import DefaultContentContainer from "@/components/shared/DefaultContainer/DefaultContentContainer";
import CashIcon from "@/components/icons/CashIcon";
import BankIcon from "@/components/icons/BankIcon";
import SmileyIcon from "@/components/icons/SmileyIcon";
import HeartDisplay from "@/components/shared/HeartDisplay";
import { Stats } from "@/types/state";
import { DefaultContainerVariantProps } from "@/components/shared/DefaultContainer/defaultContainerVariants";
import clsx from "clsx";
import {formatCurrency} from "@/utils/currencyutils";

type Props = {
    className?: string;
    stats: Stats;
    theme: DefaultContainerVariantProps["theme"];
};

const GameEndStatsDisplay = ({ stats, theme }: Props) => {
    return (
        <div
            className={clsx(
                "grid grid-cols-3 gap-2 w-full",
                theme === "sharescreen" ? "text-secondary-500/90" : "text-white/65",
            )}
        >
            <DefaultContentContainer
                theme={theme}
                rounded="sm"
                shadow={false}
                className={clsx("flex w-full cursor-pointer flex-col items-center justify-between", theme==="sharescreen" ? "px-3 py-2 gap-y-[7px]": "p-2 gap-2")}
            >
                <div className="flex justify-between items-center w-full leading-[115%]">
                    <div className="font-bold mr-0.5 text-xs">Cash</div>
                    <CashIcon />
                </div>
                <div className={clsx("text-left w-full", theme === "sharescreen" ? "text-secondary-500 font-medium text-xl leading-[115%]" : "text-white")}>
                    {formatCurrency(stats.cash)}
                    <span className={clsx(" ml-0.5", theme === "sharescreen" ? "text-base font-medium": "text-xs")}>€</span>
                </div>
            </DefaultContentContainer>
            <DefaultContentContainer
                theme={theme}
                rounded="sm"
                shadow={false}
                className={clsx("flex w-full cursor-pointer flex-col items-center justify-between", theme==="sharescreen" ? "px-3 py-2 gap-y-[7px]": "p-2 gap-2")}
            >
                <div className="flex justify-between items-center w-full leading-[115%]">
                    <div className="font-bold mr-0.5 text-xs">Depot</div>
                    <BankIcon />
                </div>
                <div className={clsx("text-left w-full", theme === "sharescreen" ? "text-secondary-500 font-medium text-xl leading-[115%]" : "text-white")}>
                    {formatCurrency(stats.investments)}
                    <span className={clsx(" ml-0.5", theme === "sharescreen" ? "text-base font-medium": "text-xs")}>€</span>
                </div>
            </DefaultContentContainer>
            <DefaultContentContainer
                theme={theme}
                rounded="sm"
                shadow={false}
                className={clsx("flex w-full cursor-pointer flex-col items-center justify-between", theme==="sharescreen" ? "px-3 py-2 gap-y-[7px]": "p-2 gap-2")}
            >
                <div className="flex justify-between items-center w-full leading-[115%]">
                    <div className="font-bold mr-0.5 text-xs">Happiness</div>
                    <SmileyIcon />
                </div>
                <HeartDisplay heartCount={stats.happiness} />
            </DefaultContentContainer>
        </div>
    );
};

export default GameEndStatsDisplay;